// Configuração centralizada da API
// Em desenvolvimento: usa localhost
// Em produção: usa o domínio de produção
const API_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'production' 
    ? 'https://easy-backend-node.athixdev.xyz/api' 
    : 'http://localhost:3992/api');

console.log('🔍 Configuração API carregada:', {
  API_URL,
  NODE_ENV: process.env.NODE_ENV,
  REACT_APP_API_URL: process.env.REACT_APP_API_URL
});

export default API_URL;
